import { render } from "./PhoneInputWithIcon.vue?vue&type=template&id=63186708&scoped=true"
import script from "./PhoneInputWithIcon.vue?vue&type=script&lang=js"
export * from "./PhoneInputWithIcon.vue?vue&type=script&lang=js"

import "./PhoneInputWithIcon.vue?vue&type=style&index=0&id=63186708&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63186708"]])

export default __exports__